/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const transactionPartyTypeEnum = {
	spark: "spark",
	lightning: "lightning",
	bitcoin: "bitcoin",
	issuer: "issuer",
	burn_address: "burn_address",
	unknown: "unknown",
} as const;

export type TransactionPartyTypeEnum =
	(typeof transactionPartyTypeEnum)[keyof typeof transactionPartyTypeEnum];

export type TransactionParty = {
	/**
	 * @type string
	 */
	type: TransactionPartyTypeEnum;
	/**
	 * @type string
	 */
	identifier: string;
	/**
	 * @type string
	 */
	pubkey?: string | null;
};
